import { IconProps } from '@/root/shared-types/ui/ui-types'
import { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const ReturnSailSepIcon: FC<IconProps> = ({ width = 20, height = 36, color = 'black', ...rest }) => (
  <Icon type="ReturnSailSep" width={width} height={height} alt="ReturnSailSepIcon" color={color} {...rest} />
)
